import React from "react";
import {toast} from "react-toastify";
import './LinkShareButton.scss'

export function LinkShareButton({url}) {

  return <button className={'link-share-btn'} onClick={
        () => {
            navigator.clipboard.writeText(url)
            toast.success("Link copiato nella clipboard")
        }
    }>
      <i className={'icon-share'}></i>
    </button>

}
